import Vue from 'vue';
import { gsap } from 'gsap';
import scrollama from 'scrollama';

Vue.component('repeating-words-component', {
    props: [],

    data() {
        return {
            progress: null,
            scrollDown: true,
        };
    },

    watch: {
    },

    mounted() {
        this.pinnedTitlesAnimation();
    },

    methods: {
        pinnedTitlesAnimation() {
            // Initiele hoogte weten van de holder, om deze vast te zetten.
            var elementsHolder = document.querySelector('.repeating-words-block');
            const elementsHolderHeight = elementsHolder.clientHeight;
            gsap.set('.repeating-words-block', {height: elementsHolderHeight})

            // Hierna moeten we de titles met gsap aanspreken from veel margin bottom naar 0 margin bottom (upcoming-events-title)
            gsap.set('.upcoming-events-title', {marginBottom: 300})
            gsap.set('.repeating-words-holder', {position: 'absolute', top: -200})

            // instantiate the scrollama
            const scroller = scrollama();

            // setup the instance, pass callback functions
            scroller
                .setup({
                    step: '.repeating-words-block',
                    offset: 0.95,
                })
                .onStepEnter(response => {
                    // { element, index, direction }
                    // console.log('Entered')
                    gsap.to('.upcoming-events-title', {marginBottom: 0, ease: "expo.out", duration: 1.5 })
                    gsap.to('.repeating-words-holder', {top: 0, ease: "expo.out", duration: 1.5 })
                })
                .onStepExit(response => {
                });

            // setup resize event
            window.addEventListener('resize', scroller.resize);
        }

    },

    beforeDestroy() {
    },
});
